import React from 'react';
import $ from "jquery";
import { Modal, Button } from 'react-bootstrap';

import { sendRequest } from './global.js';
import Storage, {T} from './Storage.js';

import FlexibleInput from './FlexibleInput.js';

var RequestView = React.createClass({
  getInitialState: function() {
    var properties = Object.assign({}, Storage.getConfig(this.props.configKey).properties);
    var config = Storage.getConfig(this.props.configKey).config;
    var keys = Object.keys(properties);
    var object = {};
    for (let i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (this.props.object && this.props.object[key]) {
        object[key] = this.props.object[key];
      } else {
        if (Array.isArray(properties[key].default)) {
          object[key] = properties[key].default.slice();
        } else if (typeof properties[key].default === "object") {
          object[key] = Object.assign({}, properties[key].default);
        } else {
          object[key] = properties[key].default;
        }
      }
    }
    var state = {
      object: object,
      properties: properties,
      config: config,
      responseContent: false,
    };
    return state;
  },

  onRequest: function(e) {
    var key = $(e.currentTarget).attr("data-key");
    sendRequest({
      method: this.state.options[key].request,
      type: this.state.options[key].type,
      success: function(data) {
        this.setState({responseContent: data});
      }.bind(this),
      error: function(xhr, status, err) {
      }
    });
  },

  onModalClose: function() {
    this.setState({responseContent: false});
  },

  handleSend: function(e) {
    e.preventDefault();
    sendRequest({
      method: this.state.config.method,
      type: this.state.config.methodType,
      data: this.state.object,
      success: function(data) {
        this.setState({responseContent: data});
      }.bind(this),
      error: function(xhr, status, err) {
      }
    });
  },

  handlePropertyChange: function(key, value) {
    var object = this.state.object;
    object[key] = value;
    this.setState({object: object});
  },

  render: function() {
    var thisView = this;
    var inputs = Object.keys(this.state.properties).map(function(key) { // eslint-disable-line
      if (thisView.state.properties[key].type !== "none") {
        var groupHidden = thisView.state.properties[key].preset && !thisView.state.object.id;
        var inputDisabled = thisView.state.properties[key].preset 
          || (!thisView.state.edit && thisView.state.object.id > 0)
          || (thisView.state.edit && thisView.state.properties[key].createOnly);
        return (
          <div className="form-group" hidden={groupHidden} key={key}>
            <label htmlFor="id" className="col-sm-2 control-label">{thisView.state.properties[key].title}</label>
            <div className="col-sm-10">
              <FlexibleInput
                object={thisView.state.object[key]}
                configKey={thisView.props.configKey}
                onChange={thisView.handlePropertyChange}
                disabled={inputDisabled}
                objectKey={key}
                objectProperties={thisView.state.properties}
              />
            </div>
          </div>
        );
      }
    });
    return (
      <div className="adminContent customScrollBar">
        <h1 className="page-header">
          {this.state.config.title}
        </h1>

        <form className="form-horizontal">
          {inputs}
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button 
                onClick={this.handleSend}
                className="btn btn-primary"
              >Send</button>
            </div>
          </div>
        </form>

        <Modal show={!!this.state.responseContent} onHide={this.onModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>{T("modal_response_title")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span className="errorMessage">{this.state.responseContent.error}</span>
            {this.state.responseContent.message}
            <br/>
            <a href={this.state.responseContent.link} target="_blank">{this.state.responseContent.link ? T("modal_response_link") : ""}</a>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onModalClose}>{T("button_close")}</Button>
          </Modal.Footer>
        </Modal>

      </div>
    )
  },
  
});

export default RequestView;



// WEBPACK FOOTER //
// ./src/RequestView.js